<template>
  <div class="shelves-right-wrap">
    <div class="func">
      <el-row>
        <!-- 添加功能暂时隐藏 @click="dialogFormVisible = true" -->
        <el-button
          type="warning"
          plain
          @click="delectAll"
          size="small"
          style="border-color:#f7ba2a;color:#f7ba2a"
        >清空采购单</el-button>
        <el-button type="warning" size="small" @click="downloadTemplate">下载模板</el-button>
        <el-upload
          class="upload-file order-upload-file"
          ref="upload"
          :action="upLoad.actionUrl"
          :headers="upLoad.headers"
          :data="upLoad.upLoadData"
          name="purchasingCartExcel"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
          :on-error="handleError"
        >
          <el-button type="warning" size="small">批量上传订单</el-button>
        </el-upload>
        <el-button
          type="text"
          class="shopCar-template"
          size="small"
          @click="teachClick"
          style="font-size:16px"
        >教程，必看，点我点我！！！</el-button>
      </el-row>
      <el-row style="margin-top:7px">
        <span style="font-size:12px">
          当前采购车内，有
          <span style="color:rgb(247, 186, 42);font-weight:800">{{ total }}</span>条商品数据
        </span>
      </el-row>
    </div>
    <div class="container" id="container">
      <el-table
        v-loading="loadingFlag"
        :data="tableData"
        style="width:1040px"
        class="shopCar_table"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="60">
        </el-table-column>-->
        <el-table-column label="操作" width="45" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="shopCar_ref"
              @click="upDateClick(scope.row)"
              v-if="upDateFlag"
            >修改</el-button>
            <el-button type="text" class="shopCar_delete" @click="delSingle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="110" class="statusColor">
          <template slot-scope="status">
            <span
              :class="{orderClour:status.row.prePayStatus=='可正常下单'||status.row.prePayStatus=='更优价格',orderClourRed:status.row.prePayStatus!='可正常下单'&&status.row.prePayStatus!='更优价格'}"
            >{{status.row.prePayStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" width="220">
          <template slot-scope="goodsInfoArr">
            <div class="goodsInfoBox">
              <div class="goodsInfoLeft">
                <img :src="goodsInfoArr.row.goodsInfoArr[0].specImage" alt />
              </div>
              <div class="goodsInfoRight">
                <div>{{goodsInfoArr.row.goodsInfoArr[0].goodsName}}</div>
                <div class="gray">{{goodsInfoArr.row.goodsInfoArr[0].specName}}</div>
                <div class="gray">{{goodsInfoArr.row.goodsInfoArr[0].productId}}</div>
                <div style="word-break: break-all;" class="gray">自有订单号：{{goodsInfoArr.row.ownerOrderSn}}</div>
                <div style="border: 1px solid rgb(103,191,135);width: 60px;text-align: center;color: rgb(64,173,104);background-color: rgb(240,255,246);font-size: 12px;display: block;" v-if="goodsInfoArr.row.isOwns == 1">自产自销</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收件人信息" width="120">
          <template slot-scope="scope1">
            <div class="addressInfo">
              <span>{{scope1.row.addressArr[0].linkMan}}</span>
              <span>{{scope1.row.addressArr[0].mobile}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收件信息" width="130">
          <template slot-scope="scope">
            <div class="adInfo">
              <span>{{scope.row.adInfoArr[0].area}}</span>
              <span>{{scope.row.adInfoArr[0].address}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140">
          <template slot-scope="scope" class="numStyle">
            <!-- :max="scope.row.maxSingleQuantity" -->
            <el-input-number
              size="mini"
              v-model="scope.row.quantity"
              :min="1"
              :class="scope.row.quantity>scope.row.maxSingleQuantity?'numRed':''"
              :max="scope.row.quantity<=scope.row.maxSingleQuantity?scope.row.maxSingleQuantity:9999999999"

              @change="addNum(scope.row)"
              class="selectAdd"
            ></el-input-number>

            <span style="display:block;margin-top:10px">{{scope.row.maxSingleQuantity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算价(+运费)" width="140">
          <template slot-scope="scope">
            <div class="fregihtPrice">
              <span>￥{{scope.row.priceArr[0].settlementPrice}}</span>
              <span
                style="display:block"
                v-show="scope.row.propStyle=='一件代发'"
              >（+{{scope.row.priceArr[0].freight}})</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="propStyle" label="类型" width="65"></el-table-column>
        <!-- <el-table-column prop="ownerOrderSn" label="自有订单号" width="120"></el-table-column> -->
        <el-table-column prop="message" label="消息" width="65"></el-table-column>
      </el-table>
    </div>
    <!-- 下单按钮 -->
    <div class="shopCarFooter" id="buttonFixed">
      <el-button
        type="warning"
        size="small"
        @click="goOrderGo"
        style="width:200px;height:50px;font-size: 16px;border-radius:0;margin-right:0px"
      >去确认订单 ({{totalOrder}})</el-button>
      <el-button
        type="warning"
        size="small"
        @click="goOrderBefor"
        style="background-color:rgb(205, 150, 72);width:200px;height:50px;font-size: 16px;border-radius:0"
      >去下单</el-button>
    </div>
    <!-- 分页效果 -->
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handlebinCurrentChange"
        :current-page.sync="pageNum"
        :total="total"
        :page-size="10"
      ></el-pagination>
    </div>
    <Shop-car-add ref="addCar" @updateListItem="updateTableData"></Shop-car-add>
  </div>
</template>

<script>
import {
  carGetDataQuery,
  carManyImport,
  carDelate,
  carGeneratOrder,
  carOrderNumAdd,
  CarDownloadTemplate,
  CarOrderNumChange,
  CarOrderUpdate,
  CarOrderNumberTotal
} from "../config/interface.js";
import { fetch, baseURL } from "../config/fetch.js";
import { toast } from "../util/tool.js";
import router from "../router/index.js";
import ShopCarAdd from "./ShopCarAdd";
export default {
  data() {
    return {
      userId: this.$store.state.userId,
      appId: this.$store.state.appId,
      upDateFlag: true, //当页面是无匹配项时去掉
      num1: 5,
      loadingFlag: false,
      formLabelWidth: "120px",
      totalOrder: null,
      value8: "",
      desc: "",
      pageSize: 10,
      pageNum: 1,
      currentPage: 1,
      total: 0,
      delectAllArr: null, //用于清空订单
      multipleSelection: [], //批次导入库存,
      // 导入数据信息
      upLoad: {
        actionUrl: baseURL + carManyImport,
        headers: {
          userToken: this.$store.state.token
        },
        upLoadData: {
          appId: this.$store.state.appId,
          userId: this.$store.state.userId
        }
      },

      //  shopCarShowOrder:this.shopCarShow, //页面的切换
      tableData: [
        //   {
        //   prePayStatus: '库存不足',
        //   goodsInfoArr:[
        //     {specImage:'图片',
        //      goodsName:'潮流一级哒哒哒哒哒哒多订单霹雳巴拉一顿好评好说好事成双买不了吃亏买不了上当',
        //      specName:'规格名：红色M',productId:'sku号：22222222'}],
        //   addressArr:[{linkMan:'大狗子',mobile:'188279279700'}],
        //   // adInfoArr:[{area:'上海宝山区',address:'逸仙路3000号上海国际工业设计中心8号楼113号'}],
        //   numMax:'295',
        //   priceArr:[{settlementPrice:14,freight:10}]
        // }
      ],
      form: {
        nam: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ]
    };
  },
  components: {
    ShopCarAdd
  },
  mounted() {
    this.init();
    this.$nextTick(function() {
      this.handleScroll();
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 表格数据初始化
    init() {
      let url = carGetDataQuery;
      let params = {
        appId: this.appId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userId: this.userId,
        bodyId: this.$store.state.bodyId,
      };
      // console.log("params");
      // console.log(params);
      fetch(url, params).then(res => {
        // console.log(111);
        // console.log("获取数据");
        // console.log(res);
        if (res.code == 10000) {
          let data = res.data.result;
          let _this = this;
          let delectAllArr = [];
          data.forEach((value, index) => {
            //  存储所有的id
            delectAllArr.push(value.id);
            // prePayStatus 状态进行处理 0无匹配项,1可正常下单,2未加入货架,3未推送,4涨价失效,5无库存
            if (value.prePayStatus == 1) {
              value.prePayStatus = "可正常下单";
            } else if (value.prePayStatus == 2) {
              value.prePayStatus = "未加入货架";
            } else if (value.prePayStatus == 3) {
              value.prePayStatus = "未推送";
            } else if (value.prePayStatus == 4) {
              value.prePayStatus = "涨价失效";
            } else if (value.prePayStatus == 5) {
              value.prePayStatus = "无库存";
            } else if (value.prePayStatus == 7) {
              value.prePayStatus = "更优价格";
            } else if (value.prePayStatus == 8) {
              value.prePayStatus = "地址格式有误";
            } else if (value.prePayStatus == 9) {
              value.prePayStatus = "区域断货";
            }  else if (value.prePayStatus == 10) {
              value.prePayStatus = "暂未开售";
            } else {
              this.upDateFlag = false;
              value.prePayStatus = "无匹配项";
            }
            //  规格进行处理
            // {specImage:'图片'},
            // {goodsName:'潮流一级哒哒哒哒哒哒多订单霹雳巴拉一顿好评好说好事成双买不了吃亏买不了上当'},
            // {specName:'规格名：红色M'},

            let goodsInfo = {};
            value.goodsInfoArr = [];
            goodsInfo.specImage = value.specImage;
            goodsInfo.goodsName = value.goodsName;
            goodsInfo.message = value.message;

            goodsInfo.specName = "规格名:" + value.specName;
            goodsInfo.productId = "SKU号:" + value.productId;
            value.goodsInfoArr.push(goodsInfo);
            // 收件人信息   addressInfo:[{linkMan:'大狗子'},{mobile:'188279279700'}],
            let address = {};
            value.addressArr = [];
            address.linkMan = value.linkMan;
            address.mobile = value.mobile;
            value.addressArr.push(address);
            //价格的组装   price:[{settlementPrice:14},{freight:10}]
            let price = {};
            value.priceArr = [];
            price.settlementPrice = value.settlementPrice / 100;
            price.freight = value.freight / 100;
            value.priceArr.push(price);
            // 收件信息 adInfoArr {area:'上海宝山区',address:'逸仙路3000号上海国际工业设计中心8号楼113号'}
            let adInfo = {};
            value.adInfoArr = [];
            adInfo.area = value.city + value.area;
            adInfo.address = value.address;
            value.adInfoArr.push(adInfo);
          });
          this.tableData = data;
          this.tableData.forEach(element => {
            if (element.appType == 1) {
              element.propStyle = "一件代发";
            } else {
              element.propStyle = "社群集采";
            }
          });

          this.delectAllArr = delectAllArr;
          this.total = res.data.count;
        }
      });
      //订单小计
      this.orderNumber();
    },
    // 订单小结
    orderNumber() {
      let url = CarOrderNumberTotal;
      let params = {
        appId: this.appId,
        userId: this.userId,
        bodyId: this.$store.state.bodyId,
      };
      fetch(url, params).then(res => {
        console.log("订单总数显示");
        console.log(res);
        this.totalOrder = res.data.totalDetailNum;
      });
    },
    // 下载模板
    downloadTemplate() {
      let url = CarDownloadTemplate;
      let params = {
        userId: this.userId
      };
      let responseType = "arraybuffer";
      fetch(url, params, responseType).then(res => {
        console.log("的流文件");
        console.log(res);
        let fileName = res.headers["content-disposition"].substring(
          res.headers["content-disposition"].indexOf("=") + 1
        );
        fileDownload(res.data, fileName);
      });
    },
    // 清空购物车
    delectAll() {
      if (this.delectAllArr.length == 0) {
        toast("采购车已清空 快去先挑选商品", 3, false);
        return;
      }
      this.$confirm("你真的要清空购物车吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning"
      })
        .then(() => {
          this.delOrder(this.delectAllArr, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除选择的
    deletSelect() {
      let length = this.multipleSelection.length;
      if (length > 0) {
        // 对删除的id进行处理
        console.log("多选的id");
        console.log(this.multipleSelection);
        let purchasingCartIds = [];
        this.multipleSelection.forEach((value, index) => {
          purchasingCartIds.push(value.id);
        });
        console.log(purchasingCartIds);
        this.$confirm("你真的要删除所选商品吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
          type: "warning"
        })
          .then(() => {
            this.delOrder(purchasingCartIds);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        toast("请选择要删除的订单", 2, false);
      }
    },
    //去订单之前
    goOrderBefor() {
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("div", null, [
          h(
            "div",
            { style: "height: 25px" },
            "1:采购车内可下单状态的订单会统一下单"
          ),
          h(
            "div",
            { style: "height: 25px" },
            "2:形成订单，占用库存，采购车内容消失"
          ),
          h(
            "div",
            { style: "height: 25px" },
            "3:点击下单后，请去确认订单页付款"
          )
        ]),
        showCancelButton: true,
        // 确定按钮
        confirmButtonText: "确定订单",
        cancelButtonText: "我在检查下",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // this.$emit('switchPage', '1');
            this.goOrder();
            done();
          } else {
            done();
            // router.replace({
            //     path: '/manage/order'
            // });
            // router.push({ path: '/manage/order' })
          }
        }
      });
    },
    // 修改功能
    upDateClick(row) {
      let url = CarOrderUpdate;
      console.log("修改的回显");
      console.log(row);
      this.$nextTick(() => {
        //  传0表示是修改的页面
        this.$refs.addCar.init(row, 0);
      });
    },
    // 修改子组件时的回调方法
    updateTableData() {
      this.init();
    },
    // 删除单个的
    delSingle(row) {
      console.log("row1");
      console.log(row);
      let purchasingCartIds = [];
      purchasingCartIds.push(row.id);
      this.delOrder(purchasingCartIds);
    },
    // 删除订单的封装
    delOrder(purchasingCartIds, num) {
      let url = carDelate;
      let params = null;
      if (num) {
        params = {
          appId: this.appId,
          purchasingCartIds: purchasingCartIds,
          truncatePurchasingCart: num,
          userId: this.userId
        };
      } else {
        params = {
          appId: this.appId,
          purchasingCartIds: purchasingCartIds,
          userId: this.userId
        };
      }
      fetch(url, params).then(res => {
        if (res.code == 10000) {
          toast("删除成功", 1, false);
          this.init();
        }
      });
    },
    // 模板教程
    teachClick() {
      this.$emit("switchPage", "3");
    },
    //选中行
    handleSelectionChange(value) {
      this.multipleSelection = value;
    },
    //  批量导入订单
    // 导入表格
    beforeUpload(file) {},
    // 上传表格成功
    handleUploadSuccess(res, file, fileList) {
      const _this = this;
      if (res.code == 10000) {
        toast("上传成功", 1, false);
        _this.pageNum = 1;
        _this.init();
      } else {
        if (res.code == 20100) {
          router.replace({
            path: "/"
          });
        } else {
          toast(res.message, 2, false);
        }
      }
    },
    // 上传表格发生错误
    handleError(file, fileList) {
      this.$message.error("上传失败请重新上传");
    },
    // 每行数量的增加
    addNum(row) {
      // alert(row.quantity)
      console.log("点击增加数量", row);
      // if (row.quantity > row.maxSingleQuantity) {
      //   row.quantity = row.maxSingleQuantity;
      // }

      this.$nextTick(() => {
        // console.log(row.quantity);
        let url = carOrderNumAdd;
        let params = {
          purchasingCartId: row.id,
          quiantity: row.quantity,
          appId: this.appId,
          userId: this.userId
        };
        console.log("添加的参数");
        console.log(params);
        fetch(url, params).then(res => {
          if (res.code == 10000) {
            console.log("添加数量的数据");
            console.log(res);
          } else {
            toast(res.message, 2, false);
          }
        });
      });
    },
    // 去下单跳转页面
    goOrderGo() {
      this.$emit("switchPage", "2");
    },
    // 去下单操作
    goOrder() {
      // console.log('去下单时的数据类型');
      // console.log(this.tableData)
      let _this = this;
      let url = carGeneratOrder;
      let params = {
        appId: this.appId,
        userId: this.userId,
        bodyId: this.$store.state.bodyId,
      };
      fetch(url, params).then(res => {
        console.log("去订单");
        console.log(res);
        if (res.code == 10000) {
          this.$nextTick(() => {
            _this.init();
          });
        } else {
          if (res.code == 20100) {
            router.replace({
              path: "/"
            });
          } else {
            toast(res.message, 2, false);
          }
        }
      });
      this.loadingFlag = true;
      setTimeout(function() {
        _this.loadingFlag = false;
        _this.init();
      }, 2000);
    },
    // 改变当前页
    handlebinCurrentChange(val) {
      this.pageNum = val;
      this.init();
    },
    // 监听滚轮
    handleScroll() {
      //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //     var oDiv = document.querySelector('#buttonFixed');
      //     // alert(oDiv);
      //      if(!oDiv){
      //       return
      //      }
      //     var oDiv2 = document.querySelector('.container');
      //     //  var oApp = document.querySelector('.shelves-right-wrap');
      //     var oApp = document.querySelector('.shopCar_table');
      //     var win = window.innerHeight;
      //  if((win - 400)+oApp.offsetHeight - scrollTop >win){
      //       oDiv.style.position="fixed";
      //       oDiv.style.top=win-40+'px';
      //       // oDiv.style.bottom=0+'px';
      //       oDiv.style.width=1048+'px';
      //     }else{
      //         oDiv.style.position="static";
      //          oDiv.style.top='0px';
      //     }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="less">
.numRed /deep/ input{
  color:red!important;
}
.func {
  height: 70px;
  margin-top: 15px;
}
.func .el-button--small {
  width: 100px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
.el-button--text {
  color: #6b6b6b !important;
}
.cell {
  text-align: center;
  font-weight: normal;
}
.shopCar_table {
  border: none !important;
}
.shopCar_table::after {
  top: 0;
  right: 0;
  width: 0px !important;
  height: 100%;
}
.shopCar_table div.cell {
  padding: 0px;
}
.shopCar_table th {
  font-size: 14px;
  /* height: 50px; */
  background-color: #eee !important;
  font-weight: normal;
  /* line-height: 50px; */
  font-family: PingFangSC;
  color: #494949;
}
.shopCar_table th > div.cell {
  background-color: #eee !important;
}
.shopCar_table tbody {
  font-size: 12px;
}
.shopCar_table tbody .shopCar_delete span {
  font-size: 12px;
  color: #6b6b6b;
}
.shopCar_table tbody .cell:first-child {
  font-size: 12px;
}
.shopCar_table thead .el-checkbox__inner {
  position: relative;
  left: -12px;
}
.shopCar_table thead .el-checkbox__inner::before {
  position: absolute;
  display: block;
  content: "全选";
  left: 17px;
  font-size: 14px;
}
.statusColor .cell {
  /* color:red; */
}
.shopCar-template {
  color: #97db4c !important;
}
.orderClour {
  color: #97db4c !important;
}
.orderClourRed {
  color: #ff3d00 !important;
}
.el-input-number--mini {
  width: 117px !important;
}

.selectAdd .el-input__inner {
  background-color: #eeeeee;
  width: 118px;
  /* background-color: #D6D6D6; */
  position: relative;
  left: -31px;
  /* padding-left: 45px !important;
  padding-right: 0px !important; */
}
.selectAdd span.el-input-number__decrease {
  left: 0px;
  border-right: 1px solid #d6d6d6 !important;
}
.el-input--mini {
  padding-left: 30px;
}
.el-message-box__btns button.el-button.el-button--default {
  float: right;
  background-color: #fea923;
  color: #fff;
  border: 1px solid #fea923;
  margin-bottom: 10px;
}
.el-message-box__btns button:nth-child(1) {
  margin-left: 30px;
}
.el-message-box__btns button.el-button.el-button--default.el-button--primary {
  background-color: #fff;
  color: #fea923;
}
/* 表格修改按钮字体的样式 */
.el-button.shopCar_ref.el-button--text {
  font-size: 12px;
  /* color: rgb(44, 162, 252); */
}
.goodsInfoBox {
  padding-top: 10px;
  /* padding-bottom:10px; */
}
/* 自定义表格样式的修改 */
.goodsInfoLeft {
  float: left;
  width: 80px;
  height: 80px;
  /* border:1px solid rgba(223, 230, 236,0.5); */
  /* color:#A2A2A2; */
  margin-bottom: 10px;
}
.goodsInfoLeft img {
  width: 80px;
  height: 80px;
}
.goodsInfoRight {
  /* border:1px solid green; */
  margin-left: 90px;
}
.goodsInfoRight div {
  line-height: 18px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #606060;
}
.goodsInfoRight span {
  display: inline-block;
  text-align: left;
  width: 100%;
}
.goodsInfoRight span:nth-last-of-type(2) {
  color: #a2a2a2;
  // margin-top: 5px;
  // margin-bottom: 8px;
}
.goodsInfoRight span:nth-last-of-type(1) {
  color: #a2a2a2;
}
.goodsInfoRight div.gray {
  color: #a2a2a2;
}
.addressInfo span {
  display: block;
  width: 100%;
  color: #606060;
}
.addressInfo span:first-of-type {
  margin-bottom: 20px;
}
.adInfo span {
  display: block;
  width: 100%;
  line-height: 18px;
  color: #606060;
}
.adInfo span:first-of-type {
  margin-bottom: 18px;
}
.fregihtPrice span {
  color: #606060;
}
.fregihtPrice span:nth-last-of-type(1) {
  color: #a2a2a2;
}
/* 下定单样式 */
.shopCarFooter {
  width: 1040px;
  height: 50px;
  background-color: #f8f8f7;
  z-index: 998;
}
.shopCarFooter button {
  float: right;
  width: 120px;
  height: 40px;
  text-align: center;
  color: #fff;
  z-index: 999;
  margin-right: 10px;
  /* background-color:#ffa726;
  border:1px solid #ffa726; */
}
.shopCar_table th.is-leaf:nth-of-type(6):before {
  content: "需要数量";
  display: block;
  clear: both;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  margin-top: 3px;
}
.shopCar_table th.is-leaf:nth-of-type(6)::after {
  content: "单门店最大可提供数量";
  display: block;
  clear: both;
  font-size: 14px;
  font-weight: normal;
  margin-top: -11px;
  margin-bottom: 4px;
}
/* .shopCar_table th:nth-last-child(6):after{
  	content:'单门店最大可提供数量';
	  display: block;
    clear: both;
     font-size: 14px;
    font-weight: normal;
    margin-top: -11px;
    margin-bottom: 4px;
    width: 140px;
    border: 1px solid red;
} */
.certainButton {
  width: 100%;
  height: 50px;
  background-color: #f8f8f7;
}
.certainButton button {
  float: right;
  width: 100px;
  height: 40px;
  text-align: center;
  color: #fff;
  z-index: 999;
}
.upload-file {
  display: inline-block;
}
.shopCar_table thead > tr > th:nth-of-type(3) {
  padding-left: 55px !important;
}
.shopCar_table .el-table__header-wrapper > table {
  width: 1040px !important;
}
.shopCar_table .el-table__header-wrapper > table > thead {
  background-color: #eeeeee !important;
}
</style>





// WEBPACK FOOTER //
// shopCar.vue?424f2e66